import _find from 'lodash/find';

// Singleton Mode
class WindowMessage {
  static _instance = null;
  TYPE = {
    NOTIFICATION: 'notification'
  }
  listeners = [];
  constructor() {
    if (!WindowMessage._instance) WindowMessage._instance = this;

    return WindowMessage._instance;
  }

  addListener(targetOrigin, callback) {
    const that = this;
    const listener = _find(that.listeners, ['origin', targetOrigin]);
    if (listener) {
      listener.callback = callback;
    } else {
      that.listeners.push({
        origin: targetOrigin,
        callback,
      });
      window.addEventListener('message', async (event) => {
        const { source, origin, data } = event;
        if (origin !== targetOrigin) return;

        const { callback: _cb } = _find(that.listeners, ['origin', origin]);
        _cb && await _cb({ source, origin, data: typeof data === 'string' ? JSON.parse(data) : data });
      });
    }
  }
}

const windowMessage = new WindowMessage();
Object.freeze(windowMessage);

export { windowMessage };
